import { useAppSessionSync } from '@crm/hooks/useAppSessionSync'
import { useMenuItems } from '@crm/hooks/useMenuItems'
import { AppNames } from '@shared/types'

import { lazy } from 'react'

const AppRouter = lazy(() => import('./AppRouter'))

export const useCrmConfig = () => {
  // Runs here rather than in AppRouter: this hook is reached as soon as the
  // shell builds the menu, while AppRouter is lazy and would only arrive after
  // the sidebar has already been rendered from a role-less session.
  useAppSessionSync()

  const menuItems = useMenuItems()

  return {
    key: AppNames.Crm,
    path: '/apps/crm/:token/*',
    menu: menuItems,
    routes: <AppRouter />
  }
}
